export const INGESTION_POLL_MS = 2000
export const VALIDATION_MIN_VISIBLE_MS = 1200
export const FILE_FORMAT_REJECT_ERROR = "wrong format"

export const formatBytes = (bytes: number): string => {
  return `${(bytes / 1024 / 1024).toFixed(1)} MB`
}

export const formatFileDate = (lastModified: number): string => {
  const date = new Date(lastModified)
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, "0")
  const day = String(date.getDate()).padStart(2, "0")
  return `${year}-${month}-${day}`
}
